<template lang="pug">
  table.assemble-the-number-table(
    :class="{\
            'assemble-the-number-table--small-border': assembleTheNumberTable.length > 6,\
        }"
  )
    tbody
      tr.assemble-the-number__row(
        v-for='(row, rowIndex) in assembleTheNumberTable',
        :key='rowIndex'
      )
        td.assemble-the-number__cell(
          v-for='(num, numIndex) in row',
          :key='numIndex'
          :style="itemStyle"
        )
          .assemble-the-number-table__press-item(
            @click='handleClick(num, rowIndex, numIndex)'
            :style="isColoredCells && getRandomCellColor()"
          )
            span
              | {{ num }}
</template>

<script>
    const BLUE_COLOR = 'hsl(212, 100%, 56%)';
    const PURPLE_COLOR = 'hsl(274, 75% , 65%)';
    const PINK_COLOR = 'hsl(348, 100%, 70%)';
    const YELLOW_COLOR = 'hsl(38, 100%, 66%)';
    const COLORS_FOR_TABLE_CELLS = [PINK_COLOR, PURPLE_COLOR, BLUE_COLOR, YELLOW_COLOR];

    export default {
        props: {
            assembleTheNumberTable: {
                type: Array,
                default: () => [],
            },
            numberOfCharacters: {
                type: Number,
                default: 2,
            },
            isColoredCells: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            window.addEventListener('resize', this.calculateSizeForAssembleTheNumberTable);
            this.calculateSizeForAssembleTheNumberTable();
        },
        data() {
            return {
                itemSize: 0,
                itemLineHeight: 73,
            };
        },
        computed: {
            itemStyle() {
                return {
                    height: this.itemSize + 'px',
                    width: this.itemSize + 'px',
                    'font-size': (this.itemLineHeight - 6 * this.numberOfCharacters) * this.fontCoefficient + 'px',
                    'line-height': this.itemLineHeight * this.fontCoefficient + 'px',
                };
            },
            fontCoefficient() {
                let coefficient = this.itemSize / this.itemLineHeight;
                if (this.assembleTheNumberTable.length > 3) {
                    coefficient *= this.assembleTheNumberTable.length > 3 ? 0.5 : 0.8;
                }
                return coefficient;
            },
        },
        methods: {
            getRandomCellColor() {
                let randomIndexForCellColor = Math.floor(Math.random() * COLORS_FOR_TABLE_CELLS.length);
                return {
                    color: COLORS_FOR_TABLE_CELLS[randomIndexForCellColor],
                };
            },
            handleClick(num, rowIndex, numIndex) {
                this.$emit('handleClick', num, rowIndex, numIndex);
            },
            calculateSizeForAssembleTheNumberTable() {
                this.itemSize = 0;
                this.$nextTick(() => {
                    let assembleTheNumberTable = document.querySelector('.assemble-the-number-table');
                    let items = Array.from(document.querySelectorAll('.assemble-the-number__cell'));
                    const isSafari =
                        /constructor/i.test(window.HTMLElement) ||
                        (function(p) {
                            return p.toString() === '[object SafariRemoteNotification]';
                        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
                    const newDimensionValue = value => (isSafari ? value * 0.88 : value);
                    let tempTableSize;
                    if (isSafari) {
                        const playBoxContainer = document.querySelector('.play-box');
                        tempTableSize = Math.min(playBoxContainer.clientWidth, playBoxContainer.clientHeight);
                    } else {
                        tempTableSize = Math.min(
                            assembleTheNumberTable.clientWidth,
                            assembleTheNumberTable.clientHeight
                        );
                    }
                    assembleTheNumberTable.style['height'] = newDimensionValue(tempTableSize) + 'px';
                    assembleTheNumberTable.style['width'] = newDimensionValue(tempTableSize) + 'px';
                    this.itemSize = newDimensionValue(items[0].clientWidth);
                });
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.calculateSizeForAssembleTheNumberTable);
        },
    };
</script>

<style scoped lang="scss">
    .assemble-the-number-table {
        width: 100%;
        height: 100%;
        @include media($lg) {
            width: 90%;
            height: 90%;
        }
        border: 10px solid $x-color-white;
        border-collapse: collapse;
        border-spacing: 0;
        table-layout: fixed;
        box-sizing: border-box;
    }

    .assemble-the-number-table--disabled .assemble-the-number-table__press-item {
        pointer-events: none;
        cursor: auto;
        &:hover {
            background-color: transparent;
        }
    }

    .assemble-the-number-table--small-border,
    .assemble-the-number-table--small-border .assemble-the-number__cell {
        border: 4px solid $x-color-white;
    }

    .assemble-the-number__cell {
        text-align: center;
        vertical-align: middle;
        border: 5px solid $x-color-white;
        box-sizing: border-box;
        background: $x-color-white;
        font-size: 62px;
        line-height: 73px;
    }

    .assemble-the-number-table__press-item {
        width: 100%;
        height: 100%;
        margin: auto;
        display: flex;
        cursor: pointer;
        user-select: none;
        align-items: center;
        border-radius: $border-radius-10;
        justify-content: center;
        color: $hsl-color-green-58;
        background-color: $hsl-color-gray-97;
        transition: background-color 0.1s;
        &:hover {
            background-color: rgba($hsl-color-green-58, 0.3);
        }
    }

    .assemble-the-number-table__press-item_green {
        color: $x-color-white;
        background-color: $hsl-color-green-58;
        &:hover {
            background-color: $hsl-color-green-58;
        }
    }

    .assemble-the-number-table__press-item_white {
        transition: none;
        background-color: $hsl-color-gray-97;
        &:hover {
            background-color: $hsl-color-gray-97;
        }
    }

    .assemble-the-number-table__press-item_red {
        transition: none;
        color: $x-color-white !important;
        background-color: $hsl-color-orange-64;
        &:hover {
            background-color: $hsl-color-orange-64;
        }
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
